// extracted by mini-css-extract-plugin
export default {"applied":"styles_applied__9ZyBf"};